import { TextImageContentModule } from '@silvertours/common-landingpages-view';

import {
  HasHeadingStyle,
  HasModuleContainerSpacingRules,
  HasTextStyleRules,
  Heading,
  LinkButton,
  ModuleContainer,
  RichText,
} from '../element';
import { HasColumns } from '../rule';
import { SectionTitle } from '../element/SectionTitle';
import { HasSectionTitleRules } from '../element/rule';

export type TextContentBlockRules = {
  isContainerMultiColumn: boolean;
  isSecondColumn?: boolean;
} & HasSectionTitleRules &
  HasColumns &
  HasHeadingStyle &
  HasModuleContainerSpacingRules &
  HasTextStyleRules;

type TextContentBlockContent = Pick<
  TextImageContentModule,
  'badge' | 'heading' | 'content' | 'link'
>;

export type TextContentBlockProps = {
  content: TextContentBlockContent;
  rules?: TextContentBlockRules;
};

export const TextContentBlock = ({
  content: { badge, heading, content, link },
  rules,
}: TextContentBlockProps) => {
  const {
    sectionTitle: sectionTitleRules,
    columns,
    heading: headingStyle = {},
    isContainerMultiColumn,
    isSecondColumn,
    textStyle,
    verticalSpacing,
  } = rules || {};
  const { style } = textStyle || {};

  return (
    <ModuleContainer
      rules={{
        isSecondColumn,
        verticalSpacing,
      }}
    >
      <SectionTitle
        content={badge}
        rules={{
          sectionTitle: sectionTitleRules,

          verticalSpacing: { isLargeAtMD: true },
        }}
      />
      <Heading
        content={heading}
        rules={{ textStyle: { style }, ...headingStyle }}
      />
      {content && (
        <RichText content={content} rules={{ columns, textStyle: { style } }} />
      )}
      <LinkButton
        content={link}
        rules={{
          variant: 'secondary',
          size: 'small',
          horizontalSpacing: { isCentered: !isContainerMultiColumn },
        }}
      />
    </ModuleContainer>
  );
};
